<script>
    import ChooseTimeCalendar from '@/online_booking/new/components/appointments/ChooseTimeCalendar';
    import {http} from '@/system/http.js';
    import filter from 'lodash/filter';
    import hasSelectedProducts from '@/online_booking/new/mixins/hasSelectedProducts.js';
    import moment from 'moment';
    import BookSoonestAppointment from '@/online_booking/new/components/appointments/BookSoonestAppointment';
    import Card from '@/online_booking/new/components/common/Card';
    import { mapActions, mapState, mapGetters } from 'vuex';
    import PreviousButton from '@/online_booking/new/components/common/PreviousButton';
    import StepCounter from "@/online_booking/new/components/common/StepCounter";
    import BookingFlowStep from '@/online_booking/new/BookingFlowStep.js';
    import { bookingKeys } from '@/online_booking/new/helpers/constants';

    export default {

        props: {
            user: {
                type: Object,
            }
        },

        mixins: [hasSelectedProducts],

        data() {
            return {
                active: false,
                active_done: false,
                loading: false,
                permalink: null,
                first_step: null,
                second_step: null,
                calendar: null,
                time: null,
                selected_date: null,
                selected_date_formatted: null,
                morning: [],
                afternoon: [],
                evening: [],
                time_ranges: 0,
                next_available: null,
                hide_no_bookings_found_alert : true,
                available_times: [],
                selected_time: null,
                waiting_list_selected: false,
                waiting_list_signup: false,
                waiting_list_preferred_time: null,
                waiting_list_comments: '',
                dateAndTimeAutoSelected: false,
                soonestLoading: false,
                soonestError: false,
                timeGroups: [],
            }
        },

        beforeUnmount() {
            this.$event_bus.$off('CalendarClicked');
            this.$event_bus.$off('booking-restart');
            this.$event_bus.$off('CalendarsShowed');
            this.$event_bus.$off('dateClicked');
            this.$event_bus.$off('LoadData');
            this.$event_bus.$off('ProductsShowed');
            this.$event_bus.$off('AddonProductsShowed');
            this.$event_bus.$off('TimesShowed');
            this.$event_bus.$off('productsChosen');
        },

        mounted() {
            let vm = this;

            this.$event_bus.$on('productsChosen', () => {
                if (
                    !this.waitingListOnly && (
                        (this.first_step === BookingFlowStep.Calendar && (this.second_step === BookingFlowStep.Products || !this.second_step))
                        || (this.first_step === BookingFlowStep.Products && this.second_step === BookingFlowStep.Times)
                    )
                ) {
                    this.openChooseTime();
                }
            });

            this.$event_bus.$on('addonProductsChosen', () => {
                if (!this.waitingListOnly) {
                    this.openChooseTime();
                }
            });

            this.$event_bus.$on('CalendarClicked', (calendar) => {
                this.dateAndTimeAutoSelected = false;
                if (
                    !this.waitingListOnly && (
                        (this.first_step === BookingFlowStep.Products && this.second_step === BookingFlowStep.Calendar)
                        || this.first_step === BookingFlowStep.Calendar
                        || this.second_step !== BookingFlowStep.Times
                    )
                ) {
                    this.calendar = calendar;
                    this.openChooseTime();
                }
            });

            this.$event_bus.$on('LoadData', (data) => {
                this.permalink = data.permalink;
                this.first_step = data.online_booking_settings.first_step;
                this.second_step = data.online_booking_settings.second_step;
            });

            this.$event_bus.$on('dateClicked', (dates) => {
                this.clean();
                this.selected_date = dates.selected;
                this.next_available = dates.next_available;
                this.hide_no_bookings_found_alert = false;

                if (this.selected_date) {
                    this.getAvailableTimes()
                }
            });

            this.$event_bus.$on('booking-restart', () => {
                this.calendar = null;
                this.active = false;
                this.active_done = false;
            });

            this.$event_bus.$on('ProductsShowed', () => {
                this.active = false;
                this.active_done = false;
                this.clean();

                if (this.first_step === 'products') {
                    this.calendar = null;
                }
            });

            this.$event_bus.$on('AddonProductsShowed', () => {
                this.active = false;
                this.active_done = false;
                this.clean();
            });

            $('#collapseTimes').off('hidden.bs.collapse');
            $('#collapseTimes').on('hidden.bs.collapse', function () {
                vm.soonestError = false;
            });

            this.$event_bus.$on('TimesShowed', () => {
                this.time = null;
                this.hide_no_bookings_found_alert = true;
                this.soonestError = false;
            });

            this.$event_bus.$on('CalendarsShowed', () => {
                if (this.second_step !== 'times') {
                    this.active = false;
                    this.active_done = false;
                    this.clean();
                }
            });

            this.$event_bus.$on('bookSoonest', (soonestData) => {
                this.calendar = soonestData.calendar;
                this.active = true;
                this.selected_date = moment(soonestData.formattedDate);
                this.selected_date_formatted = soonestData.formattedDate;
                this.dateAndTimeAutoSelected = true;
                this.timeSet(soonestData.timeData, true);
            });
        },

        methods: {
            ...mapActions('OnlineBooking', ['setCurrentStep', 'setSelectedValue']),

            openChooseTime() {
                if (this.hasSelectedProducts) {
                    this.active = true;
                    if ($(window).width() < 500) {
                        setTimeout(function(){
                            $('html, body').animate({scrollTop:$('#booking-accordion').offset().top});
                        }, 250);
                    }

                    this.triggerStateChange();
                }
            },

            clean() {
                this.time_ranges = 0;
                this.waiting_list_signup = false;
                this.morning = [];
                this.afternoon = [];
                this.evening = [];
                this.time = null;
                this.waiting_list_preferred_time = null;
                this.waiting_list_comments = '';
                this.timeGroups = [];
            },

            timeSet(time, isSoonest) {
                this.active_done = true;
                this.time = time.time;
                this.waiting_list_selected = !time.available;
                this.$event_bus.$emit('timeSet', time.time, this.isFullyBooked, this.waiting_list_selected, isSoonest);
            },

            waitingListTimeSet(time, $event) {
                this.time = time.time;
                this.waiting_list_preferred_time = time.time
                if($event.target.className.includes('selected-preferred-time')){
                    this.waiting_list_preferred_time = null
                    this.time = null
                }
                this.waiting_list_selected = !time.available;
            },

            continueToFillInformation() {
                this.active_done = true;
                this.waiting_list_selected = 1;
                var selected_time = this.waiting_list_preferred_time ? this.waiting_list_preferred_time.date : this.selected_date.format('YYYY-MM-DD HH:mm')
                var fullDaySignup = this.waiting_list_preferred_time ? 0 : 1
                this.time = { date: selected_time };
                this.$event_bus.$emit('preferredTimeSet', selected_time, fullDaySignup, this.waiting_list_comments, this.isFullyBooked, this.waiting_list_selected);
            },

            getAvailableTimes() {
                let productIds = this.selectedProductIds.concat(this.selectedAddonProductIds);

                if (productIds.length <= 0) {
                    this.clean();
                    return;
                }

                this.loading = true;
                this.hide_no_bookings_found_alert = true;
                http.post('/online_booking/getAvailableTimes', {
                    calendar_id: this.calendar ? this.calendar.id : null,
                    permalink: this.permalink,
                    product_ids: productIds,
                    date: this.selected_date.format('YYYY-MM-DD')
                })
                    .then(({ data }) => {
                        this.clean();
                        this.available_times = data.available_times;

                        if (!this.isFullyBooked) {
                            this.organizeTimes(this.available_times);
                        }

                        this.selected_date_formatted = data.chosen_date_formatted;
                        this.loading = false;
                        this.hide_no_bookings_found_alert = false;
                    })
                    .catch(({error, errorBag}) => {
                        this.loading = false;
                    });
            },

            organizeTimes(times) {
                for (let key of Object.keys(times)) {
                    if(times[key].available){
                        let hour = moment(times[key].time.date).format('HH');

                        if (hour >= 0 && hour < 12) {
                            this.morning.push(times[key]);
                        } else if (hour >= 12 && hour < 18) {
                            this.afternoon.push(times[key]);
                        } else if (hour >= 18 && hour <= 24) {
                            this.evening.push(times[key]);
                        }
                    }
                }

                this.time_ranges = 0;

                if (this.morning.length > 0) {
                    this.time_ranges++;
                    this.timeGroups.push('morning');
                }

                if (this.afternoon.length > 0) {
                    this.time_ranges++;
                    this.timeGroups.push('afternoon');
                }

                if (this.evening.length > 0) {
                    this.time_ranges++;
                    this.timeGroups.push('evening');
                }
            },

            getTimeFormatted(time) {
                return moment(time.date).format('HH:mm');
            },

            nextAvailable() {
                this.$event_bus.$emit('nextAvailable');
            },

            async handleBookSoonest () {
                this.soonestLoading = true;
                this.loading = true;
                try {
                    const res = await http.post('/online_booking/getSoonestAvailableTime', {
                        product_ids: this.selectedProductIds,
                        permalink: this.permalink
                    });
                    if (!res.data.available_time) {
                        res.data.available_time = this.available_times[0];
                    }
                    this.$event_bus.$emit('bookSoonest', {
                        timeData: res.data.available_time,
                        formattedDate: res.data.chosen_date_formatted,
                        calendar: res.data.available_time.calendar
                    });
                } catch (e) {
                    this.soonestError = true;
                } finally {
                    this.soonestLoading = false;
                    this.loading = false;
                }
            },

            triggerStateChange () {
                this.setCurrentStep('time');
            },
        },

        computed: {
            ...mapState('OnlineBooking', ['currentStep']),
            ...mapGetters('OnlineBooking', ['getPreviousStepId', 'currentStepNumber', 'totalStepCount', 'waitingListOnly']),

            isFullyBooked() {
                return !this.available_times || this.available_times.length === 0;
            },

            isWaitingListEnabled() {
                return this.user
                    ? this.user.waiting_list_active
                    : false
            },

            waitingListTimeSlots() {
                if (!this.isWaitingListEnabled || !this.selected_date) {
                    return [];
                }

                return filter(this.available_times, function (t) {
                    return !t.available;
                });
            },

            isTimeStepActive () {
                return this.currentStep === 'time';
            },

            formattedDateTimeString () {
                // variables
                if (!this.time || !this.selected_date_formatted) {
                    return '';
                }

                const time = this.getTimeFormatted(this.time);
                const date = this.selected_date_formatted;

                const displayTime = this.waiting_list_selected && time === '00:00' ? this.trans('waiting_list.all_day') : time;
                const waitingList = this.isFullyBooked && !this.dateAndTimeAutoSelected ? ' - ' + this.trans('waiting_list.title') : '';

                const joinWaitingList = this.waiting_list_selected ? `${this.trans('waiting_list.confirm_booking')} -` : '';

                return `${joinWaitingList} ${date}, ${displayTime} ${waitingList}`.trim() || ''
                // [Join Waiting List - or ''] [formatted date], [all day] || [formatted time] [- Waiting Lists] || ''
            },
        },

        components: {
            StepCounter,
            ChooseTimeCalendar,
            BookSoonestAppointment,
            Card,
            PreviousButton
        },

        watch: {
            isTimeStepActive (newValue) {
                if (newValue) {
                    this.$event_bus.$emit('TimesShowed');
                    window.location.hash = 'choose-time';
                    if (this.dateAndTimeAutoSelected) {
                        /*
                        ** Since while auto selecting the calendar, date and time
                        ** we are not doing apis for the dates and times
                        ** So to make sure that the date and time apis are fetched
                        ** we artificially make this flow happen.
                        */
                        this.$event_bus.$emit('CalendarClicked', this.calendar);
                    }
                }
            },

            formattedDateTimeString (newValue) {
                this.setSelectedValue({
                    key: bookingKeys.TIME,
                    value: newValue,
                })
            },
        },
    };


</script>


<template>
    <div class="time-container" v-show="isTimeStepActive">
        <card class="p-0 overflow-hidden rounded-lg" id="choose-time-panel">
            <h4 class="section-title">
                <step-counter :total="totalStepCount" :current="currentStepNumber" />
                {{ trans('online_booking.common.choose_date_time') }}
            </h4>
            <div
                id="collapseTimes"
                role="tabpanel"
                aria-labelledby="headingTimes"
                data-parent="#booking-accordion"
            >
                <book-soonest-appointment
                    class="pt-6"
                    v-if="second_step === 'times'"
                    @bookSoonest="handleBookSoonest"
                    :loading="soonestLoading"
                    :hasError="soonestError"
                />

                <div class="panel-body py-6" id="time-body-booking">
                    <div class="row">
                        <div class="col-sm-7">
                            <div class="date-picker-wrapper">
                                <choose-time-calendar
                                    :soonest-loading="soonestLoading"
                                    :is-waiting-list-enabled="isWaitingListEnabled">
                                </choose-time-calendar>
                            </div>
                        </div>
                        <!-- Alert - Loading -->
                        <div class="col-sm-5 m-t-10 text-center" v-if="loading">
                            <div class="preloader"></div>
                        </div>
                        <div class="col-sm-5" v-if="time_ranges > 0 && !loading">
                            <h4 class="m-t-0 m-b-5" v-if="!waiting_list_signup">
                                {{ trans('online_booking.available_times') }}
                                {{ selected_date_formatted }}
                            </h4>


                            <div class="row" v-if="!waiting_list_signup">
                                <div class="col-xs-12">
                                    <div
                                        class="time-groups-content"
                                        v-for="(group, i) in timeGroups"
                                        :key="i"
                                    >
                                        <div class="time-group-item-content">
                                            <!-- when the day with the waiting list is clicked have sweet alert and on okay call timeSet(time, true) -->
                                            <h6 class="m-b-10">{{ trans(`global.${group}`) }}</h6>
                                            <a class="btn btn-default time-box-btn btn-sm m-r-10 available"
                                               v-for="(time, j) in $data[group]"
                                               :key="j"
                                               @click="timeSet(time)"
                                               role="button"
                                               v-tooltip="time.available ? '' : trans('waiting_list.confirm_booking')"
                                               aria-controls="collapseFillInfo"
                                            >
                                                {{ getTimeFormatted(time.time) }}
                                            </a>
                                        </div>
                                    </div>
                                </div>

                                <!-- only if there are unavailable times that day -->
                                <div class="col-xs-12 border-box-time" v-if="waitingListTimeSlots.length > 0">
                                    <p class="m-t-20" > {{ trans('waiting_list.join_waiting_list_1') }}<span class="waiting-list-signup-link" @click="waiting_list_signup=true"> {{ trans('waiting_list.join_waiting_list_2') }}</span></p>
                                </div>

                            </div>

                            <!-- if user wants to sign up for waiting list -->
                            <div class="row" v-if="waiting_list_signup">
                                <div class="col-xs-12">
                                    <h4 class="m-t-0">
                                        {{ trans('waiting_list.waiting_list_date', {time: selected_date_formatted }) }}
                                    </h4>
                                    <p class="m-0">
                                        {{ trans('waiting_list.specify_preferred_time') }} </p>
                                </div>
                                <div class="col-xs-12 waiting-list-times m-t-10">
                                    <h6 class="m-b-10" >{{ trans('waiting_list.preferred_time') }} ({{ trans('online_booking.optional') }})</h6>
                                    <a  v-show="!time.available"
                                        v-for="(time, index) in available_times" :key="index" @click="waitingListTimeSet(time, $event)" role="button"
                                        class="btn btn-default btn-sm m-r-10 m-b-10 unavailable"
                                        :class="[time.time == waiting_list_preferred_time ? 'selected-preferred-time' : '']">
                                        <i class="zmdi zmdi-check m-r-5" v-if="time.time == waiting_list_preferred_time"></i> {{ getTimeFormatted(time.time) }}
                                    </a>
                                </div>
                                <div class="col-xs-12 m-t-5">
                                    <h6 class="m-b-10" >{{ trans('online_booking.fill_notes') }} ({{ trans('online_booking.optional') }})</h6>
                                    <textarea v-model="waiting_list_comments" name="waiting-list-notes" id="waiting-list-notes" cols="40" rows="3"></textarea>
                                </div>
                                <div class="col-xs-12">
                                    <div class="signup-buttons">
                                        <small @click="waiting_list_signup=false" class="back-to-selection"> <i class="zmdi zmdi-arrow-left m-r-5"></i>{{ trans('waiting_list.return_to_time_selection') }} </small>
                                    </div>
                                </div>

                            </div>
                        </div>
                        <!-- Alert - No available dates -->
                        <div class="col-sm-5 m-t-10" v-if="time_ranges == 0 && !loading">
                            <div  class="text-center" v-if="next_available && !hide_no_bookings_found_alert">
                                <div class="row">
                                    <div class="hidden-xs col-md-12">
                                        <i class="zmdi zmdi-calendar-close" style="font-size: 100px;"></i>
                                    </div>
                                    <div class="col-xs-12 col-md-12">
                                        <h4 class="m-b-0">{{ trans('online_booking.no_available_times') }}</h4> <br>
                                        <a v-on:click="nextAvailable" class="btn btn-default">{{ trans('online_booking.go_to_next_available_time') }}<i class="m-l-10 zmdi zmdi-chevron-right"></i></a>
                                    </div>
                                </div>

                            </div>

                            <div class="text-center" v-if="!next_available && !isWaitingListEnabled && !hide_no_bookings_found_alert">
                                <i class="zmdi zmdi-calendar-close m-b-20" style="font-size: 100px;"></i><br>
                                <h4>{{ trans('online_booking.no_available_times_this_year') }}</h4>
                            </div>

                            <div class="text-center" v-if="!next_available && isWaitingListEnabled && !waiting_list_signup && !hide_no_bookings_found_alert">
                                <i class="zmdi zmdi-calendar-close m-b-20" style="font-size: 100px;"></i><br>
                                <h4>{{ trans('online_booking.no_available_times_this_date') }}</h4>
                                <div class="border-box-time" v-if="waitingListTimeSlots.length > 0">
                                    <p class="m-t-20" >{{ trans('waiting_list.join_waiting_list_1') }}<span class="waiting-list-signup-link" @click="waiting_list_signup=true"> {{ trans('waiting_list.join_waiting_list_2') }}</span></p>
                                </div>
                            </div>

                            <div class="row" v-if=" !next_available && isWaitingListEnabled && waiting_list_signup">
                                <div class="col-xs-12 m-t-5">
                                    <h4 class="m-t-0">
                                        {{ trans('waiting_list.waiting_list_date', {time: selected_date_formatted }) }}
                                    </h4>
                                    <p class="m-0">
                                        {{ trans('waiting_list.specify_preferred_time') }} </p>
                                </div>
                                <div class="col-xs-12 waiting-list-times m-t-10">
                                    <h6 class="m-b-10" >{{ trans('waiting_list.preferred_time') }} ({{ trans('online_booking.optional') }})</h6>
                                    <a  v-show="!time.available"
                                        v-for="(time, index) in available_times" :key="index" @click="waitingListTimeSet(time, $event)" role="button"
                                        class="btn btn-default btn-sm m-r-10 m-b-10 unavailable"
                                        :class="[time.time == waiting_list_preferred_time ? 'selected-preferred-time' : '']">
                                        <i class="zmdi zmdi-check m-r-5" v-if="time.time == waiting_list_preferred_time"></i> {{ getTimeFormatted(time.time) }}
                                    </a>
                                </div>
                                <div class="col-xs-12 m-t-5">
                                    <h6 class="m-b-10" >{{ trans('online_booking.fill_notes') }} ({{ trans('online_booking.optional') }})</h6>
                                    <textarea v-model="waiting_list_comments" name="waiting-list-notes" id="waiting-list-notes" cols="40" rows="3"></textarea>
                                </div>
                                <div class="col-xs-12">
                                    <div class="signup-buttons">
                                        <small @click="waiting_list_signup=false; hide_no_bookings_found_alert=false;" class="back-to-selection"> <i class="zmdi zmdi-arrow-left m-r-5"></i>{{ trans('waiting_list.return_to_time_selection') }} </small>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- End of Alert -->
                    </div>
                </div>
            </div>
            <div class="signup-buttons flex justify-between flex-wrap gap-6 p-6 pt-0">
                <previous-button :previous-step-id="getPreviousStepId" />
                <button
                    v-if="waiting_list_signup"
                    @click="continueToFillInformation()"
                    class="btn btn-custom sm:w-auto"
                >
                    <span>{{ trans('global.continue') }}</span>
                    <i class="zmdi zmdi-arrow-right ml-3"></i>
                </button>
            </div>
        </card>
    </div>
</template>
